export default __webpack_public_path__ + "static/Reactathon_Mar_2019-1c8c85d6e4dfeb0f8c0612034fd61349.jpeg";